import { render, staticRenderFns } from "./hqStuHealthUserShow.vue?vue&type=template&id=57de60da&scoped=true"
import script from "./hqStuHealthUserShow.vue?vue&type=script&lang=js"
export * from "./hqStuHealthUserShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de60da",
  null
  
)

export default component.exports